export default __webpack_public_path__ + "static/herohello-c133a525fc1f51d43973f6968786fee2.png";